import { render, staticRenderFns } from "./XmlErrors.vue?vue&type=template&id=495528f4"
import script from "./XmlErrors.vue?vue&type=script&lang=js"
export * from "./XmlErrors.vue?vue&type=script&lang=js"
import style0 from "./XmlErrors.vue?vue&type=style&index=0&id=495528f4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports